import { IAppState } from 'shared/common/state';

export const animationShownCountSelector = (state: IAppState): number => {
  return state.consultantCianChat.animationShownCount;
};
